import * as R from 'ramda'
import { of } from 'rxjs'
import { delayWhen, tap, take, ignoreElements } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import { getDeviceInfo, INTERFACE_WEBSITE } from 'helpers/useragent'
import { getMemberId, getMemberState, getLoggedIn, getQuery } from 'store/selectors'
import { reset, register, identify } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import { disableMixPanelTracking } from '../disable'

// type DefaultMixpanelMPProps = {
//   Interface: string,
//   'Member ID': string,
// }

const getDefaultMPProperties = (state) => ({
  'Interface': getDeviceInfo(window.navigator.userAgent).interface,
  'Member ID': getMemberId(state)
})

const hasMPProperties = query => Boolean(R.prop('mp_properties', query))

const identifyFromMemberId = R.compose(
  identify,
  getMemberId
)

const registerFromDefaultMPProperties = R.compose(
  register,
  getDefaultMPProperties
)

const registerFromQuery = (query) => {
  let mpProps = JSON.parse(atob(query?.mp_properties))

  if (mpProps?.Interface === INTERFACE_WEBSITE) {
    const interfaceProp = { 'Interface': getDeviceInfo(window.navigator.userAgent).interface }
    mpProps = { ...mpProps, ...interfaceProp }
  }

  register(mpProps)
}

const registerMixpanelEpic = (
  actions$,
  state$
) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(LOCATION_CHANGE),
  take(1),
  delayWhen(() => {
    if (getMemberState(state$.value) && getLoggedIn(state$.value)) {
      return of({})
    }

    return actions$.pipe(ofType(Actions.member.MEMBER_INFO_FETCHED))
  }),
  tap(() => {
    const query = getQuery(state$.value)

    reset()

    if (hasMPProperties(query)) {
      registerFromQuery(query)
    } else {
      registerFromDefaultMPProperties(state$.value)
    }

    identifyFromMemberId(state$.value)
  }),
  ignoreElements()
)

export default registerMixpanelEpic
